<template>
    <label :for="id" class="drop-area d-flex align-items-center justify-content-center m-3">
        <div class="d-flex flex-column align-items-center justify-content-center drop-area-content p-5">
            <img src="../../assets/mirage-uploading.png" alt="" style="width: 300px; height: auto">
            <span class="text-primary font-weight-bold" style="font-size: 1.2em;">Drag and drop files here...</span>
            <small class="text-secondary font-weight-light mt-2">...or click to upload.</small>
        </div>
        <input type="file" multiple="multiple" :id="id" style="display: none;">
    </label>
</template>
<script>
export default {
    props: {
        id: String
    }
}
</script>
<style lang="scss" scoped>
@import '../../styles/bootstrap/_custom';

.drop-area {
    background: rgba(0,0,0,0.02);
    text-align: center;
    border: $primary dashed 2px;
    border-radius: 5px;
    min-height: 10em;
    cursor: pointer;
    transition: all 0.3s ease;
    > .drop-area-content {
        height: 100%;
        width: 100%;
        pointer-events: none;
        position: relative;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/upload-file/upload-file-target.vue